import { ItemID } from "types/common";

import React from "react";

import { getMatchedItemIds } from "../helpers/matchedItemIds";

import { useMatchingUrlQueryService } from "modules/MatchingModule/helpers/useMatchingUrlQueryService";

import { MATCHED_BRAND_KEY, MATCHED_ITEM_KEY } from "../consts";

export const useMatchedProductFilter = () => {
  const urlQueryService = useMatchingUrlQueryService();

  const brandId = (urlQueryService.getValueByKey(MATCHED_BRAND_KEY) as ItemID | null) || "";
  const matchedItemValue = (urlQueryService.getValueByKey(MATCHED_ITEM_KEY) as string | null) || "";
  const matchedItemIds = React.useMemo(
    () => (matchedItemValue ? matchedItemValue.split(",") : []),
    [matchedItemValue]
  );

  // brandProductIds: the brand's products that rows in the view are matched to
  const selectBrand = React.useCallback(
    (nextBrandId: ItemID, brandProductIds: ItemID[]) => {
      urlQueryService.setMultipleSearchParams({
        [MATCHED_BRAND_KEY]: nextBrandId,
        [MATCHED_ITEM_KEY]: getMatchedItemIds(nextBrandId, brandProductIds, []),
      });
    },
    [urlQueryService]
  );

  const setTickedProducts = React.useCallback(
    (brandProductIds: ItemID[], tickedIds: ItemID[]) => {
      if (!brandId) return;
      urlQueryService.setSearchParam(MATCHED_ITEM_KEY, getMatchedItemIds(brandId, brandProductIds, tickedIds));
    },
    [brandId, urlQueryService]
  );

  const clear = React.useCallback(() => {
    urlQueryService.setMultipleSearchParams({ [MATCHED_BRAND_KEY]: [], [MATCHED_ITEM_KEY]: [] });
  }, [urlQueryService]);

  return { brandId, matchedItemIds, selectBrand, setTickedProducts, clear };
};
